/** API values: DELIVERY, PICKUP */
export function formatFulfillmentMethod(value) {
  if (!value || value === 'DELIVERY') return 'Delivery';
  if (value === 'PICKUP') return 'Pick-up';
  return value;
}
